// extracted by mini-css-extract-plugin
export var aiStarIcon = "_an-4";
export var closeButton = "_an-6";
export var dismissButton = "_an-3";
export var editImageWithAiContainer = "_an-8";
export var imageUploadWrapper = "_an-7";
export var misspelledWord = "_an-5";
export var spellCheckContainer = "_an-2";
export var spin = "_an-1";
export var spinning = "_an-0";